/** @jsx jsx */
import { jsx } from "theme-ui"
import {
  motion,
  useViewportScroll,
  useTransform,
  useSpring,
} from "framer-motion"

const AnimateParallax = ({
  index,
  strength = 200,
  spring = { stiffness: 200, damping: 100 },
  ...otherProps
}) => {
  const { scrollYProgress } = useViewportScroll()
  const y = useTransform(scrollYProgress, value => {
    return index % 2 ? -value * strength : value * strength
  })
  const animY = useSpring(y, spring)

  return <motion.div style={{ y: animY }} {...otherProps} />
}
export default AnimateParallax
